import { useEffect } from 'react';
import Navbar from '@/pages/home/components/Navbar';
import Hero from './components/Hero';
import CategoryDropdown from './components/CategoryDropdown';
import CategoryGrid from './components/CategoryGrid';
import ArticleSection from './components/ArticleSection';
import CtaBanner from './components/CtaBanner';
import Footer from './components/Footer';
import WhatIsSection from './components/WhatIsSection';
import FeaturesSection from './components/FeaturesSection';

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <article>
          <Hero />
          <WhatIsSection />
          <CategoryDropdown />
          <CategoryGrid />
          <FeaturesSection />
          <ArticleSection />
          <CtaBanner />
        </article>
        <Footer />
      </main>
    </>
  );
}